export default __webpack_public_path__ + "static/media/henan-2-1point5-768x513.d676566f.jpg";